import styled, { css } from "styled-components/macro";
import Icon from "./Icon";
import { useRef } from "react";
import Logo from '../images/ki-logo.png'

const Wrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    height:100%;
    padding-top: ${props => props.isDesktop ? '30px' : '0px'};
`

const CloseMapButton = styled.div`
    position:absolute;
    z-index:1;

    ${ props => props.isDesktop && css`
        top: 52px;
        left: 27px;
        transform: translateX(-100%);
    `}

    ${ props => !props.isDesktop && css`
        top: calc(-50vh + 25px);
        left: 25px;
    `}

    border: 2px solid #F79A37;
    border-radius:4px;
    padding: 14px 16px;

    color:#fff;
    background:rgba(12,62,141,0.2);
    // backdrop-filter: blur(10px);
    font-size:1.7rem;
    font-weight:700;
    @media(max-width: 768px){
        font-size: 2.1rem;
    }

    svg {
        position:relative;
        top:2px;
        margin-right:10px;
        path {
            fill: #F79A37;
        }
    } 

    &:hover {
        cursor:pointer;
        background:#0C3E8D;
    }
`


const MainBlock = styled.div`
    position:relative;
    width: 100%;
    background-color:#fff;
    border-radius:5px;
    padding:20px 35px 45px 35px;
    flex-shrink:0;
    margin-left:25px;
    margin-bottom: 7px;
    z-index:2;
    ${ props => props.isDesktop && css`
        // width:400px;
    `}
    ${ props => !props.isDesktop && css`
        padding: 20px 30px 0 30px;
        margin:0;
        &::after { 
            content:"";
            position:absolute;
            width:calc(100% - 60px);
            height:1px;
            background-color:#CAD2DD;
            bottom:0px;
            left:30px;
        }
    `}
`

const NumberContainer = styled.div`
    position:absolute;
    left:0;
    top: ${props => props.isDesktop ? '30px' : '0px'};
`

const NumberWrapper = styled.div`
    position:relative;
    margin-top:-36%;
    margin-left:35px;
`

const Marker = styled.div`
    @media(max-width:550px){
        transform:scale(0.8);
    }

`

const Number = styled.div`
    color:#fff;
    font-size:2.6rem;
    font-weight:bold;
    position:absolute;
    top:47%;
    left:50%;
    transform: translateX(-50%) translateY(-50%);
`

const Title = styled.h2`
    font-family: 'GT America Extended', 'GT America', sans-serif;
    font-weight: 700;
    font-size: 2rem;
    line-height: 130%;
    color:#0C3E8D;
    margin:2rem 0;
    @media(max-width: 768px){
        font-size: 2.5rem;
    }
`

const Description = styled.div`
    font-size: 1.7rem;
    line-height: 160%;
    color:#0C3E8D;
    margin-bottom: 2rem;
    @media(max-width: 768px){
        font-size: 2.1rem;
    }
`

const SubBlockWrapper = styled.div`

`

const SubBlock = styled.div`

`

const ChildContainer = styled.div`
    flex-grow:1;
    overflow-y:auto;
    padding-left:25px;
    position:relative;
    ${ props => !props.isDesktop && css`
        padding-bottom:40px;
        padding-top:16px;
        padding-right:25px;
    `}
`

const ChildTitle = styled.h3`
    color:#fff;
    margin:0;
    font-size:1.9rem;
    font-weight:700;
    position:relative;
    z-index:1;
    margin-bottom:12px;
    @media(max-width: 768px){
        font-size: 2.2rem;
    }
`

const ChildDesc = styled.div`
    color:#fff;
    position:relative;
    z-index:1;
    font-size:1.6rem;
    font-weight:400;
    line-height:160%;
    margin-bottom:12px;
    @media(max-width: 768px){
        font-size: 2rem;
    }
`

const MainLink = styled.a`
    color:#0C3E8D;
    position:relative;
    z-index:1;
    font-weight:700;
    font-size:1.6rem;
    text-decoration:none;
    svg {
        margin-left: 10px;
        position: relative;
        top: 3px;
        path {
            fill: #F79A37;
        }
    }
    transition: color .2s ease-out;
    @media(max-width: 768px){
        font-size: 2rem;
    }
`

const ChildLink = styled.a`
    color:#fff;
    position:relative;
    z-index:1;
    font-weight:700;
    font-size:1.6rem;
    text-decoration:none;
    svg {
        margin-left: 10px;
        position: relative;
        top: 3px;
    }
    transition: color .2s ease-out;
    @media(max-width: 768px){
        font-size: 2rem;
    }
`

const ChildIcon = styled.div`
    position:absolute;
    left:-22px;
    top: 16px;

`

const ChildIconSecond = styled.div`
    position:absolute;
    left:-22px;
    top: 76px;
    .hexicon-bg {
        fill:  ${ props => props.color };
    } 
`

const ChildBlock = styled.div`
    position:relative;
    background-color:#0B2957;
    border-radius:5px;
    padding: 30px 35px 30px 35px;
    margin-bottom:7px;
    &:last-child {
        margin-bottom:25px;
    }
    ${ChildIcon} {
        .hexicon-bg {
            fill:  ${ props => props.color };
        }
        .interactive-icon--dots {
            ${ props => props.color !== '#FFFFFF' && css`
                .hexicon-bg {
                    fill:  ${ props => props.color };
                }
                path:not(.hexicon-bg) {
                    fill: #fff;
                }
            `}
        }
    }
    ${ChildLink}{
        svg path {
            fill:  ${ props => props.color };
        }
        &:hover {
            color : ${ props => props.color };
        }
    }
`

const LogoSplash = styled.img`
    opacity:0.2;
    position:absolute;
    right:20px;
    bottom:0;
    height:90%;
    width:auto;
    z-index:0;
`


const JumpLinks = styled.div`
    position:relative;
    display:flex;
    align-items:center;
    padding:16px 0;
`

const JumpLink = styled.div`
    background-color:#F0F3F8;
    border-radius:5px;
    display:flex;
    align-items:center;
    padding:6px 10px;
    margin-right:1.2rem;
    .interactive-icon--arrow-down {
        path {
            fill: #F79A37;
        }
    }
    &:hover {
        background-color:#e6e9f3;
        cursor:pointer;
    }
`

const JumpLinkIcon = styled.div`
    position:relative;
    margin-right:12px;
    .hexicon-bg {
        fill:  ${ props => props.color };
    }
    .interactive-icon--dots {
        ${ props => props.color !== '#FFFFFF' && css`
            .hexicon-bg {
                fill:  ${ props => props.color };
            }
            path:not(.hexicon-bg) {
                fill: #fff;
            }
        `}
    }
`


export default function Product(props){

    let pin = props.content;
    const jumpLink1 = useRef(null);
    const jumpLink2 = useRef(null);
    const jumpLink3 = useRef(null);
    const childContainer = useRef();

    function getColor(col){
        switch (col){
            case 'Green' :
                return "#4CC223";
            case 'Blue' :
                return '#10B6DB';
            case 'Purple' :
                return '#9737F7';
            case 'Orange' :
                return '#F79A37';
            case 'White - Dots Only' :
                return '#FFFFFF';
            default :
                return '#F79A37';
        }
    }

    function handleJumpClick(jump){
        let offsetTop = 0;
        if (jump === '1'){
            offsetTop = jumpLink1.current.offsetTop;
        }
        if (jump === '2'){
            offsetTop = jumpLink2.current.offsetTop;
        }
        if (jump === '3'){
            offsetTop = jumpLink3.current.offsetTop;
        }

        childContainer.current.scrollTo({
            top:offsetTop,
            behavior:'smooth'
        })
     
    }

    const handlePress = e => {
        if(e.key === 'Enter') { 
            props.setActivePinNumber(null)
        }
    }


    return(
        <Wrapper>

            <CloseMapButton onClick={()=>props.setActivePinNumber(null)} isDesktop={props.isDesktop}  tabIndex={0} onKeyPress={handlePress}> 
                <Icon type="Arrow Left"/> 
                Back To Map
            </CloseMapButton>

           <MainBlock isDesktop={props.isDesktop}>

                <NumberContainer>
                    <NumberWrapper>
                        <Marker>
                        <svg width="53" height="61" viewBox="0 0 53 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28 4.40215L26.5 3.53613L25 4.40215L4.64844 16.1521L3.14844 17.0181V18.7502V42.2502V43.9823L4.64844 44.8483L25 56.5983L26.5 57.4643L28 56.5983L48.3516 44.8483L49.8516 43.9823V42.2502V18.7502V17.0181L48.3516 16.1521L28 4.40215Z" fill="#F79A37" stroke="white" stroke-width="3"/>
                            <path d="M14.6458 39C13.6257 38.422 11.9847 35.7783 12.0512 35.0982C13.1157 28.4421 10.1884 21.1654 10.0332 20.2049C10.0332 20.2049 9.85576 19.8223 10.3215 20.1028C10.9128 20.7234 11.4303 21.3099 12.2656 22.738C12.7609 23.3926 16.0725 33.058 14.6458 39Z" fill="white"/>
                            <path d="M36.2286 20.7824C29.8497 20.6319 19.8171 25.3411 19.8853 25.2742C20.9243 24.2035 22.9343 21.9452 23.0875 21.1422C23.1812 20.9748 23.0534 20.7992 23.0534 20.7992C22.9086 20.3475 21.4949 19.1012 21.4098 19.0259C21.3076 18.9591 21.299 19.0427 21.299 19.0427C20.7455 20.9581 15.0479 25.4499 15.5674 27.5911C16.6575 31.0791 19.8257 30.9536 19.8257 30.9536C21.4012 31.1042 24.6971 30.5354 26.2642 31.054C26.2812 31.054 26.2812 31.0624 26.2812 31.0624C26.3324 31.0457 26.2983 30.962 26.2983 30.962C25.8724 30.134 25.0293 29.0466 24.5694 28.963C21.5375 28.3858 20.8902 29.1637 17.4325 28.7622C17.4751 28.2017 18.8207 26.5205 18.8293 26.4787C19.2891 27.1395 19.4765 27.5326 20.1578 28.0094C20.3026 28.1014 20.4389 27.9759 20.4389 27.9759C23.3005 26.4369 26.8604 25.2156 26.8604 25.2156C32.9157 23.0492 37.9575 22.1208 41.0575 23.5176C41.9006 26.211 39.5075 30.1674 39.1242 30.7947C36.43 35.3785 24.7945 46.2551 14 52.0059C15.7322 53.0285 16.2495 53.2842 17.5432 54C20.6602 53.2388 49.9232 31.8821 41.4748 23.0241C40.1462 21.7025 39.0476 20.8243 36.2201 20.7824H36.2286Z" fill="white"/>
                        </svg>
                        </Marker>
                    </NumberWrapper>
                </NumberContainer>

                <Title>{pin['Title']}</Title>
                { props.isDesktop ?
                    <>
                        <Description>{pin['Description']}</Description>
                        <MainLink href={pin["Main Link"]} target="_blank">Learn how we support<span className="visually-hidden"> {pin["Title"]} in new tab</span> <Icon type="Arrow Right" /></MainLink>
                    </>
                : null }

           </MainBlock>

           <ChildContainer ref={childContainer} isDesktop={props.isDesktop}>

                { !props.isDesktop ?
                    <>
                        <Description>{pin['Description']}</Description>
                        <MainLink href={pin["Main Link"]} target="_blank">Learn how we support<span className="visually-hidden"> {pin["Title"]} in new tab</span> <Icon type="Arrow Right" /></MainLink>
                    </>
                : null }

                { !props.isDesktop ?
                    <JumpLinks>
                        { pin['Block 1 Title']  ?
                            <JumpLink onClick={()=>handleJumpClick('1')}>
                                <JumpLinkIcon color={getColor(pin['Block 1 Colour'])}> 
                                    <Icon type={pin["Block 1 Icon"]} />
                                </JumpLinkIcon>
                                <Icon type={"Arrow Down"} />
                            </JumpLink> 
                        : null }
                        { pin['Block 2 Title']  ?
                        <JumpLink onClick={()=>handleJumpClick('2')}>
                            <JumpLinkIcon color={getColor(pin['Block 2 Colour'])}> 
                                <Icon type={pin["Block 2 Icon"]} />
                            </JumpLinkIcon>
                            <Icon type={"Arrow Down"} />
                        </JumpLink>
                        : null }
                        { pin['Block 3 Title']  ?
                        <JumpLink onClick={()=>handleJumpClick('3')}>
                            <JumpLinkIcon color={getColor(pin['Block 3 Colour'])}> 
                                <Icon type={pin["Block 3 Icon"]} />
                            </JumpLinkIcon>
                            <Icon type={"Arrow Down"} />
                        </JumpLink>
                        : null }
                    </JumpLinks>
                    : null
                }


                { pin['Block 1 Title']  ?
                    <ChildBlock color={getColor(pin['Block 1 Colour'])} ref={jumpLink1}>
                        {pin["Block 1 Icon"] ?
                            <ChildIcon> 
                                <Icon type={pin["Block 1 Icon"]} />
                            </ChildIcon>
                            : null
                        }      
                        <ChildTitle>{pin["Block 1 Title"]}</ChildTitle>
                        <ChildDesc>{pin["Block 1 Description"]}</ChildDesc>
                        { pin["Block 1 Link"] ?
                            <ChildLink href={pin["Block 1 Link"]} target="_blank">Learn how we support<span className="visually-hidden"> {pin["Block 1 Title"]} in new tab</span><Icon type="Arrow Right" /></ChildLink>
                        : null }
                    </ChildBlock>
                : null }

                { pin['Block 2 Title']  ?
                    <ChildBlock color={getColor(pin['Block 2 Colour'])} ref={jumpLink2}>
                        {pin["Block 2 Icon"] ?
                            <ChildIcon> 
                                <Icon type={pin["Block 2 Icon"]} />
                            </ChildIcon>
                            : null
                        }    
                        { pin["Block 2B Icon"] ?
                        <ChildIconSecond color={getColor(pin['Block 2B Colour'])}> 
                            <Icon type={pin["Block 2B Icon"]} />
                        </ChildIconSecond>
                        : null }
                        <ChildTitle>{pin["Block 2 Title"]}</ChildTitle>
                        <ChildDesc>{pin["Block 2 Description"]}</ChildDesc>
                        { pin["Block 2 Link"] ?
                            <ChildLink href={pin["Block 2 Link"]} target="_blank">Learn how we support<span className="visually-hidden"> {pin["Block 2 Title"]} in new tab</span> <Icon type="Arrow Right" /></ChildLink>
                        : null }
                    </ChildBlock>
                : null }

                { pin['Block 3 Title']  ?
                    <ChildBlock color={getColor(pin['Block 3 Colour'])} ref={jumpLink3}>
                        {/* <LogoSplash src={Logo} alt="" /> */}
                        {pin["Block 3 Icon"] ?
                            <ChildIcon> 
                                <Icon type={pin["Block 3 Icon"]} />
                            </ChildIcon>
                            : null
                        }    
                        <ChildTitle>{pin["Block 3 Title"]}</ChildTitle>
                        <ChildDesc>{pin["Block 3 Description"]}</ChildDesc>
                        { pin["Block 3 Link"] ?
                            <ChildLink href={pin["Block 3 Link"]} target="_blank">Learn how we support<span className="visually-hidden"> {pin["Block 3 Title"]} in new tab</span><Icon type="Arrow Right" /></ChildLink>
                        : null }
                       
                    </ChildBlock>
                : null }
               

           </ChildContainer>

           
    
        </Wrapper>
    )
}